<template>

  <router-link to="/content/epr-hive" class="c-countdown-timer">
    <header>
      <picture>
        <source srcset="/assets/hive-timer-banner--desktop.png" media="(min-width: 1024px)" />
        <img src="/assets/hive-timer-banner--mobile.png" alt="A yellow hexagon with the text Go Live In... and a white hexagon with the Hive logo" />
      </picture>

    </header>

    <main>
      <countdown
        :time="endTime"
        :transform="transform"
        role="timer"
        aria-live="polite"
        aria-atomic="true"
      >
        <template slot-scope="props">
          <ol class="listless c-countdown-timer__list">
            <li v-if="endTime < 0">
                 <span>Hive is Live!</span>
            </li>
             <li v-else-if="props.days == '0'">
               Hive is coming
            </li>
            <li v-else-if="props.days == '1'">
               <span>{{ props.days }}  day</span>  to Go Live!
            </li>
              <li v-else>
               <span>{{ props.days }}  days</span>  to Go Live!
            </li>
          </ol></template
        >
      </countdown>
      <div class="dots">
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>
        <i/>

      </div>


    </main>
    <footer>
      <img src="/assets/hive-timer-banner--right.png" alt="HIVE logo" />
    </footer>
  </router-link>

</template>

<script>
import VueCountdown from '@chenfengyuan/vue-countdown';

/**
 * Countdown timer component
 *
 * Accepts a start/stop date for displaying and counting down
 *
 * `components/TheCountdownTimer.vue`
 */
export default {
  name: 'TheCountdownTimer',
  components: {
    Countdown: VueCountdown,
  },
  methods: {
    /**
     * Modify the output of the countdown timer
     */
    transform(props) {
      // calculate weeks
      // if (props.days > 7) {
      //   props.weeks = 0;

      //   while (props.days >= 7) {
      //     props.weeks += 1;
      //     props.days -= 7;
      //   }
      // }

      Object.entries(props).forEach(([key, value]) => {
        // Adds leading zero
        const digits = value;

        props[key] = digits;
      });

      return props;
    },
  },
  props: {
    // The date from which the timer should start.  Determines whether to display the counter or not
    startTime: {
      type: [String, Date],
      default: null,
    },
    // The end time.  Needs to be a counter of seconds left as opposed to an end time stamp
    endTime: {
      type: [String, Date, Number],
      default: 2 * 24 * 60 * 60 * 1000, // 2 days
    },
  },
};
</script>

<style lang="scss" scoped>
.c-countdown-timer {
  align-items: center;
  background: #ffffff;
  color: $hive-yellow;
  display: flex;
  font-size: 0.75rem;
  justify-content: space-between;
  text-decoration: none;

  li {
    align-items: center;
    display: flex;
    color: $colour-nhs-mid-grey;
    flex-direction: column;
     font-size: 1.525rem;
     line-height: 1.3rem;
    @supports (gap: 5px) {
      gap: 5px;
    }

    @supports not (gap: 5px) {
      margin-right: 5px;
    }
    span {
      color: $colour-nhs-emergency-red;
      display: inline-block;
      font-size: 1.525rem;
      line-height: 1.4rem;

      font-family: $font-frutiger-bold;
    }
  }

  main {
    display: inline-flex;
    flex-grow: 1;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    .dots {
      display: none;
    }
  }

  footer {
    align-self: flex-start;
    display: none;
  }

  @media screen and (min-width: 768px) {

    main {
      position: relative;
      height:89px;
      .dots {
      position: absolute;
      display: block;
      width:100%;
      bottom:0px;
      height:19px;
      right:0;
      left:0;
    }
    i {
      background-color: $hive-teal;
      width:13px;
      height:13px;
      display: inline-block;
      border-radius: 20px;
      margin:0 5px;
    }
    }
    &__list {
      li {
        display: inline-flex;
        margin-right: 5px;
        flex-direction: row;
        font-size: 2.2rem;
        line-height: 1.4rem;
      }
      li span {
        align-items: center;
        justify-content: center;
        display: inline-flex;
        position: relative;
        text-align: center;
        margin-right: 5px;
        font-size: 2.2rem;
        line-height: 1.4rem;
      }

    }
  }

  @media screen and (min-width: 1024px) {
    font-size: 1.125rem;
    main {
      .dots {

        bottom:4px;
        i {
          display: none;
        }
        i:nth-child(-n+16) {
          display: inline-block;
        }
      }
    }
    &__list {
      li {
        margin-right: 10px;
        font-size: 2rem;

      }
      li span {
        font-size: 2rem;

      }
    }
  }

  @media screen and (min-width: 1352px) {

    main {
     > span {
        margin-top:-10px;
      }
      .dots {
        i {
          display: none;
          &:nth-child(-n+16) {
            display: none;
          }
          &:nth-child(-n+9) {
            display: inline-block;
          }
        }
      }
    }
    &__list {

      li,
      li span {
          font-size: 1.6rem;
          line-height: 1.2rem;
        }
    }
    @supports (gap: 5px) {
      gap: 5px;
    }

    @supports not (gap: 5px) {
      margin-right: 5px;
    }
    footer {
      display: block;
    }
  }
 @media screen and (min-width: 1472px) {
    &__list {

      li,
      li span {
          font-size: 2.2rem;
          line-height: 1.6rem;
        }
    }

    main {
     > span {
        margin-top:-6px;
      }
      .dots {
        i {
          display: none;
          &:nth-child(-n+16) {
            display: none;
          }
          &:nth-child(-n+14) {
            display: inline-block;
          }
        }
      }
    }
 }


}
</style>
